import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getAvailableFiles: language => {
    return axios.get(`${url}support/available-files/${language}`)
  },

  getFileGroups: keys => {
    const params = keys && keys.length > 0 ? `?keys=${keys.join(',')}` : ''
    return axios.get(`${url}support/file-groups${params}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/support.js